/**
 * DialogOptionButton.js
 * Created on 23-sep-2013
 * 
 * A DialogOptionButton has a second set of textfields for title:
 * "labelUpLabelTextField" etc
 * 
 * @author Reinier Feijen for Ranj
 **/

import Button from "./Button";

export default class DialogOptionButton extends Button {
    constructor(skin, wordWrap) {
        super(skin, wordWrap);
        this._title = null;
    }

    //
    setTitle(string) {
        this._title = string;
        if (this.skin) {
            for (let i = 0; i < Button.TEXTFIELDNAMES.length; i++) {
                let name = Button.TEXTFIELDNAMES[i];
                name = `label${name.substr(0, 1).toUpperCase()}${name.substr(1)}`;
                if (this.skin[name]) {
                    this.skin[name].text = this._title ? this._title : "";
                }
            }

            this.updateCache();
        }
    }

    getTitle() {
        return this._title;
    }

    _setState(state) {
        super._setState(state);
        //hide all titles
        for (let i = 0; i < Button.TEXTFIELDNAMES.length; i++) {
            var name = Button.TEXTFIELDNAMES[i];
            name = `label${name.substr(0, 1).toUpperCase()}${name.substr(1)}`;
            if (this.skin[name]) this.skin[name].visible = false;
        }
        //show active label
        name = `label${state.substr(0, 1).toUpperCase()}${state.substr(1)}LabelTextField`;//TODO: use TEXTFIELDNAMES
        if (this.skin[name]) this.skin[name].visible = true;

        this.updateCache();
    }
}